/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContactDto } from './contactDto';
import { UserAddressDto } from './userAddressDto';
import { AdminOrderComment } from './adminOrderComment';
import { OofOrderItemDto } from './oofOrderItemDto';


export interface OofOrderDto { 
    fakturaId?: string;
    offerNumber?: string;
    status?: OofOrderDto.StatusEnum;
    mainContact?: ContactDto;
    secondaryContact?: ContactDto;
    customerAccountEmail?: string;
    displayInformationalDatepickers?: boolean;
    useOldIridiumPlans?: boolean;
    creationTimestamp?: string;
    deliveryAddress?: UserAddressDto;
    invoiceAddress?: UserAddressDto;
    deliverySameAsInvoiceAddress?: boolean;
    paymentMethod?: OofOrderDto.PaymentMethodEnum;
    purchaseOrderNo?: string;
    pickUpOrder?: boolean;
    contactPriorDispatch?: boolean;
    comments?: string;
    organisationNumber?: number;
    adminComments?: Array<AdminOrderComment>;
    id?: string;
    updateTimestamp?: string;
    eInvoicing?: boolean;
    orderItems?: Array<OofOrderItemDto>;
}
export namespace OofOrderDto {
    export const StatusEnum = {
        Created: 'CREATED',
        AssignedToCustomer: 'ASSIGNED_TO_CUSTOMER',
        Submitted: 'SUBMITTED',
        InProduction: 'IN_PRODUCTION',
        Packed: 'PACKED',
        Shipped: 'SHIPPED',
        Canceled: 'CANCELED',
        All: 'ALL',
        AllUnresolved: 'ALL_UNRESOLVED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
    export const PaymentMethodEnum = {
        BankWireTransfer: 'bank_wire_transfer',
        Check: 'check',
        CreditCard: 'credit_card',
        PurchaseOrder: 'purchase_order'
    } as const;
    export type PaymentMethodEnum = typeof PaymentMethodEnum[keyof typeof PaymentMethodEnum];
}


export type PaymentMethodEnum = typeof OofOrderDto.PaymentMethodEnum[keyof typeof OofOrderDto.PaymentMethodEnum];
